import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { Dismiss as DismissIcon, SparklesFilled } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';

import { ArticleSummary } from './ArticleSummary';
import RelatedQuestions from './RelatedQuestions';
import { SitePickerSection } from './sitePickerSection';
import { DATA_HOOKS } from '../../dataHooks';

import css from './index.module.scss';


type ArticleRightSideBarProps = {
  showRightSideBar: boolean;
  setShowRightSideBar: (showRightSideBar: boolean) => void;
};

export const ArticleRightSideBar = ({ showRightSideBar, setShowRightSideBar }: ArticleRightSideBarProps) => {
  const { t } = useTranslation();

  const summary = "Use animations to bring your site to life. Add effects such as \"Float-in\" and \"Expand-in\" to create imaginative, striking pages and draw visitors' attention to your content.\nYou can apply animations to a variety of elements, and even apply different effects to the same element on both your desktop and mobile sites.Animation on your mobile site is set to suit and fit smaller screens, so you can continue to wow your visitors.Learn more about animation effects on your mobile site";
  const relatedQuestions = [
    'What is the best way to animate my site?',
    'How can I apply different effects to the same element on both my desktop and mobile sites?',
    'What are the best practices for animating my site?',
  ];

  return (<Box
    className={
      classNames(css.wrapper,
        { [css.showRightSideBar]: showRightSideBar, [css.hideRightSideBar]: !showRightSideBar }
      )
    }
    direction="vertical"
    align='space-between'
  >
    <Box direction='vertical'>
      <Box gap="8px" >
        <SparklesFilled className={css.copilotIcon} />
        <Heading size="medium" >{t('article-page.copilot.title')}</Heading>
      </Box>
      <SitePickerSection />
      <ArticleSummary summary={summary} />
    </Box>
    <Box>
      <RelatedQuestions relatedQuestions={relatedQuestions} />
    </Box>
    <DismissIcon
      className={css.dismissIcon}
      data-hook={DATA_HOOKS.ARTICLE_RIGHT_SIDEBAR_DISMISS_BUTTON}
      onClick={() => setShowRightSideBar(false)} />
  </Box >
  );
};
